module.exports = __webpack_public_path__ + "img/Wave.392ebcf6.svg";